<template>
  <div class="page-user-edit">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">客服專區</div>
      <div class="breadcrumb-item">新增會員</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Row>
          <Col span="18" push="5">
            <Form :label-width="150">
              <Row :gutter="15">
                <Col span="14">
                  <FormItem>
                    <div slot="label" class="form-label">
                      <em class="red">* </em>
                      <span>帳號(手機號碼)</span>
                    </div>
                    <Input v-model="form.phone" />
                  </FormItem>
                </Col>
              </Row>

              <Row :gutter="15">
                <Col span="14">
                  <FormItem>
                    <div slot="label" class="form-label">
                      <em class="red">* </em>
                      <span>密碼</span>
                    </div>
                    <Input v-model="form.password" />
                  </FormItem>
                </Col>
              </Row>

              <Row :gutter="15">
                <Col span="14">
                  <FormItem>
                    <div slot="label" class="form-label">
                      <em class="red">* </em>
                      <span>關聯門店</span>
                    </div>
                    <Select
                      style="width: 100%"
                      placeholder="選擇門店"
                      v-model="form.store_id"
                    >
                      <Option
                        :value="item.ReceivingID"
                        v-for="(item, index) in editList"
                        :key="item.ReceivingID"
                        >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>

              <FormItem>
                <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleCheckForm">新增</div>
                  <div class="pg-btn" @click="handleBack">返回</div>
                </div>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editList: [],
      isSubmiting: false,
      form: {
        password: "",
        phone: "",
        store_id: "",
      },
    };
  },
  mounted() {
    this.getShopList();
  },
  methods: {
    handleBack() {
      this.$router.go(-1);
    },
    getShopList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
            type: 1, //type 1門店， 2是智能櫃
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.editList = res.data.data.filter((it) => it.company_id != 15);
          }
        });
    },
    handleCheckForm() {
      let form = this.form;
      if (form.phone == "") {
        this.$Utils.showTipInfo("請輸入帳號(手機號碼)");
        return;
      }
      if (form.password == "") {
        this.$Utils.showTipInfo("請選擇密碼");
        return;
      }
      if (form.store_id == "") {
        this.$Utils.showTipInfo("請選擇關聯門店");
        return;
      }
      this.handleSubmit();
    },
    handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq
        .requestAuth({
          url: this.$Api.customer_register,
          method: "post",
          data: {
            password: form.password,
            phone: form.phone,
            storeId: form.store_id,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            this.$Utils.showSuccess(res.msg);
          } else {
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "customerRegister.scss";
</style>
